import { level1 } from './level1';
import { level2 } from './level2';
import { level3 } from './level3';
import { level4 } from './level4';
import { level5 } from './level5';
import { level6 } from './level6';
import { level7 } from './level7';
import { level8 } from './level8';
import { level9 } from './level9';
import { level10 } from './level10';
import { boss1 } from './boss1';
import type { LevelConfig } from '../index';

export const levels: Record<string, LevelConfig> = {
  level_1: level1,
  level_2: level2,
  level_3: level3,
  level_4: level4,
  level_5: level5,
  level_6: level6,
  level_7: level7,
  level_8: level8,
  level_9: level9,
  level_10: level10,
  boss_1: boss1,
};

export function getLevelConfig(id: string): LevelConfig | undefined {
  return levels[id];
}

export function getAllLevelIds(): string[] {
  return Object.keys(levels);
}
